import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const nav = useNavigate();

  const login = async e => {
    e.preventDefault();
   // const res = await axios.post('http://localhost:5000/api/admin/login', form);
    localStorage.setItem('adminToken', "fgmfhjgvbfmjdgsdhkksjgf");
    nav('/admin/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-700 to-purple-700">
      <form onSubmit={login} className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
        <input className="w-full mb-4 px-4 py-2 border rounded-lg" type="email" placeholder="Email" onChange={e => setForm({...form, email: e.target.value})} required />
        <input className="w-full mb-6 px-4 py-2 border rounded-lg" type="password" placeholder="Password" onChange={e => setForm({...form, password: e.target.value})} required />
        <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2 rounded-lg font-semibold">Login</button>
      </form>
    </div>
  );
}